export default __webpack_public_path__ + "static/media/profile.02865048.png";